import React from 'react';

const ThemeParkIcon = (props) => {
  return (
    <img
      alt="Park rozrywki"
      src="/static/images/icons/place_types/theme_park.svg"
      {...props}
    />
  );
};

export default ThemeParkIcon;
